// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AvatarGroup_wrapper","avatar":"AvatarGroup_avatar","counter":"AvatarGroup_counter"};